import React from "react"
import { StaticImage } from "gatsby-plugin-image"

const ImageMO46 = () => {

  return (
    <StaticImage
      src="../../images/JPG-FEMALE-LOOK004-6.jpg"
      title="Reserved avatar"
      alt="Reserved avatar"
    />
  )
}

export default ImageMO46
